<template>
  <div class="user_index">
    <page-header :title="$tc('user.name', 2)">
    </page-header>
    <page-content>
      <ntm-block :collapsable="false">
        <template slot="options">
<!--          <input type="text" class="form-control" :placeholder="$t('search')" v-model="search">-->
          <button @click="inviteListModal()" type="button" class="btn btn-sm btn-success">{{ $tc('invite.name', 2) }}</button>
          <button @click="addMemberModal()" type="button" class="btn btn-sm btn-success">{{ $t('user.add') }}</button>
        </template>
        <div class="table-responsive">
          <ntm-table :show-columns="showColumns" :data="model" @pageChange="setPage" :loading="loading" >
            <template slot="actions" slot-scope="{row}">
              <button v-if="user.isSuperAdmin && user.uuid !== row.uuid" @click="impersonateUser(row)" class="btn btn-sm btn-warning" v-tooltip="$t('member.seeAs')">
                <i class="fa fa-eye"></i>
              </button>
              <button v-if="user.uuid !== row.uuid && (user.isSuperAdmin || currentClient.role === 'OWNER' || currentClient.role === 'ADMIN')" @click="editMember(row)" class="btn btn-sm btn-info" v-tooltip="$t('action.edit')">
                <i class="fa fa-pencil"></i>
              </button>
              <button v-if="user.uuid !== row.uuid && (user.isSuperAdmin || currentClient.role === 'OWNER' || currentClient.role === 'ADMIN')" @click="deleteMember(row.id)" class="btn btn-sm btn-danger" v-tooltip="$t('action.delete')">
                <i class="fa fa-trash"></i>
              </button>
            </template>
          </ntm-table>
        </div>
      </ntm-block>
    </page-content>
    <modal name="invite-user" :adaptive="true" height="auto">
      <form @submit.prevent="sendInvite()">
        <ntm-block :collapsable="false" title="Invite User">
          <template #options>
            <button type="button" class="btn btn-sm btn-light" @click="$modal.hide('invite-user')" v-tooltip="$t('close')">
              <i class="fa fa-times"></i>
            </button>
          </template>
          <formly-form :form="invite.form" :model="invite.model" :fields="inviteFields"></formly-form>
          <div class="d-flex mb-2 justify-content-center">
            <button class="btn btn-success push-15 mr-2" :disabled="invite.loading"><span
              v-if="!invite.loading">{{ $t('invite.send') }}</span><i v-if="invite.loading"
                                                        class="fa fa-cog fa-spin"></i></button>
          </div>
          <hr>
          <table class="table table-sm table-bordered mb-3">
            <thead>
              <tr>
                <th>{{ $t('role.name') }}</th>
                <th>{{ $t('role.description') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>{{ $t('select.options.OWNER') }}</strong></td>
                <td>
                  {{ $t('role.ownerDescription') }}
                  <div class="mt-1">
                    <span class="badge badge-danger mr-1">Billing</span>
                    <span class="badge badge-primary mr-1">Manager</span>
                    <span class="badge badge-warning mr-1">Scorekeeper</span>
                    <span class="badge badge-info">Media</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td><strong>{{ $t('select.options.ADMIN') }}</strong></td>
                <td>
                  {{ $t('role.adminDescription') }}
                  <div class="mt-1">
                    <span class="badge badge-primary mr-1">Manager</span>
                    <span class="badge badge-warning mr-1">Scorekeeper</span>
                    <span class="badge badge-info">Media</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td><strong>{{ $t('select.options.MANAGER') }}</strong></td>
                <td>
                  {{ $t('role.managerDescription') }}
                  <div class="mt-1">
                    <span class="badge badge-warning mr-1">Scorekeeper</span>
                    <span class="badge badge-info">Media</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td><strong>{{ $t('select.options.SCOREKEEPER') }}</strong></td>
                <td>
                  {{ $t('role.scorekeeperDescription') }}
                  <div class="mt-1">
                    <span class="badge badge-warning">Scorekeeper</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td><strong>{{ $t('select.options.MEDIA_MANAGER') }}</strong></td>
                <td>
                  {{ $t('role.mediaDescription') }}
                  <div class="mt-1">
                    <span class="badge badge-info">Media</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </ntm-block>
      </form>
    </modal>
    <modal name="invite-list" :adaptive="true" height="auto">
      <ntm-block :collapsable="false" title="Invites">
        <template #options>
          <button type="button" class="btn btn-sm btn-light" @click="$modal.hide('invite-list')" v-tooltip="$t('close')">
            <i class="fa fa-times"></i>
          </button>
        </template>
        <ntm-table :show-columns="showInviteColumns" :data="invites" >
          <template slot="actions" slot-scope="{row}">
            <button v-if="user.uuid !== row.uuid && (user.isSuperAdmin || currentClient.role === 'OWNER' || currentClient.role === 'ADMIN')" @click="resendInvite(row)" class="btn btn-sm btn-info" v-tooltip="$t('tooltip.resendInvite')">
              <i v-if="!row.isLoading" class="fa fa-send"></i><i v-if="row.isLoading" class="fa fa-cog fa-spin"></i>
            </button>
            <button v-if="user.uuid !== row.uuid && (user.isSuperAdmin || currentClient.role === 'OWNER' || currentClient.role === 'ADMIN')" @click="deleteInvite(row)" class="btn btn-sm btn-danger" v-tooltip="$t('action.delete')">
              <i class="fa fa-trash"></i>
            </button>
          </template>
        </ntm-table>
      </ntm-block>
    </modal>
    <modal name="update-member" :adaptive="true" height="auto">
      <form @submit.prevent="updateMember()">
        <ntm-block :collapsable="false" :title="$t('member.edit')">
          <template #options>
            <button type="button" class="btn btn-sm btn-light" @click="$modal.hide('update-member')" v-tooltip="$t('close')">
              <i class="fa fa-times"></i>
            </button>
          </template>
          <formly-form :form="updateMemberForm" :model="updateMemberModel" :fields="updateMemberFields"></formly-form>
          <button class="btn btn-success push-15" :disabled="updateMemberLoading"><span
            v-if="!updateMemberLoading">{{ $t('save') }}</span><i v-if="updateMemberLoading"
                                                                  class="fa fa-cog fa-spin"></i></button>
          <hr>
          <table class="table table-sm table-bordered mb-0">
            <thead>
              <tr>
                <th>{{ $t('role.name') }}</th>
                <th>{{ $t('role.description') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>{{ $t('select.options.OWNER') }}</strong></td>
                <td>
                  {{ $t('role.ownerDescription') }}
                  <div class="mt-1">
                    <span class="badge badge-danger mr-1">Billing</span>
                    <span class="badge badge-primary mr-1">Manager</span>
                    <span class="badge badge-warning">Scorekeeper</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td><strong>{{ $t('select.options.ADMIN') }}</strong></td>
                <td>
                  {{ $t('role.adminDescription') }}
                  <div class="mt-1">
                    <span class="badge badge-primary mr-1">Manager</span>
                    <span class="badge badge-warning">Scorekeeper</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td><strong>{{ $t('select.options.MANAGER') }}</strong></td>
                <td>
                  {{ $t('role.managerDescription') }}
                  <div class="mt-1">
                    <span class="badge badge-warning">Scorekeeper</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td><strong>{{ $t('select.options.SCOREKEEPER') }}</strong></td>
                <td>
                  {{ $t('role.scorekeeperDescription') }}
                  <div class="mt-1">
                    <span class="badge badge-warning">Scorekeeper</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td><strong>{{ $t('select.options.MEDIA_MANAGER') }}</strong></td>
                <td>
                  {{ $t('role.mediaDescription') }}
                  <div class="mt-1">
                    <span class="badge badge-warning">Media</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </ntm-block>
      </form>
    </modal>
  </div>
</template>
<script>
import basicIndexMixin from '@/mixins/basic.index.mixin'
import MemberService from '@/services/member.service'
import InviteService from '@/services/invite.service'

export default {
  mixins: [basicIndexMixin],
  data () {
    return {
      invites: [],
      showInviteColumns: [
        {
          name: 'email',
          prop: 'email'
        },
        {
          name: 'role',
          prop: 'role',
          type: 'option'
        }
      ],
      updateMemberForm: {},
      updateMemberModel: {},
      updateMemberLoading: false,
      invite: {
        loading: false,
        form: {},
        model: {
          email: null,
          role: null
        }
      },
      showColumns: [
        {
          name: 'name',
          prop: 'name'
        },
        {
          name: 'email',
          prop: 'email'
        },
        {
          name: 'role',
          prop: 'role',
          type: 'option'
        }
      ]
    }
  },
  mounted () {
    this.fetchData()
  },
  computed: {
    inviteFields () {
      let roles = ['ADMIN', 'MANAGER', 'SCOREKEEPER', 'MEDIA_MANAGER']

      if (this.user.isSuperAdmin || this.currentClient.role === 'OWNER') {
        roles = ['OWNER', 'ADMIN', 'MANAGER', 'SCOREKEEPER', 'MEDIA_MANAGER']
      }

      return [
        {
          key: 'email',
          type: 'input',
          templateOptions: {
            label: 'email'
          }
        },
        {
          key: 'role',
          type: 'ntm-select',
          options: roles,
          isString: true,
          templateOptions: {
            translated: true,
            label: 'role'
          }
        }
      ]
    },
    updateMemberFields () {
      let roles = ['ADMIN', 'MANAGER', 'SCOREKEEPER', 'MEDIA_MANAGER']

      if (this.user.isSuperAdmin || this.currentClient.role === 'OWNER') {
        roles = ['OWNER', 'ADMIN', 'MANAGER', 'SCOREKEEPER', 'MEDIA_MANAGER']
      }

      return [
        {
          key: 'role',
          type: 'ntm-select',
          options: roles,
          isString: true,
          templateOptions: {
            translated: true,
            label: 'role'
          }
        }
      ]
    },
    user () {
      return this.$store.state.user
    },
    currentClient () {
      return this.$store.state.currentClient
    }
  },
  methods: {
    async impersonateUser (member) {
      if (member.role === 'SCOREKEEPER' || member.role === 'MANAGER' || member.role === 'MEDIA_MANAGER') {
        const response = await this.$store.dispatch('createHandoff', member.uuid)
        const scorekeeperUrl = process.env.VUE_APP_SCOREKEEPER_URL
        window.open(`${scorekeeperUrl}/auth/impersonate/${response.key}`, '_blank')
      } else {
        this.$store.dispatch('startImpersonation', {
          memberUuid: member.uuid,
          memberName: member.name
        })
      }
    },
    resendInvite (invite) {
      invite.isLoading = true
      InviteService.resend(invite.uuid).then(() => {
        this.fetchInvoiceData()
      }).finally(() => {
        invite.isLoading = false
      })
    },
    editMember (member) {
      this.updateMemberModel = member
      this.$modal.show('update-member')
    },
    updateMember () {
      this.updateMemberLoading = true

      MemberService.update(this.updateMemberModel.id, this.updateMemberModel).then(() => {
        this.$modal.hide('update-member')
        this.fetchData()
      }).finally(() => {
        this.updateMemberLoading = false
      })
    },
    deleteMember (uuid) {
      MemberService.delete(uuid).then(() => {
        this.fetchData()
      })
    },
    async inviteListModal () {
      await this.fetchInvoiceData()
      this.$modal.show('invite-list')
    },
    addMemberModal () {
      this.$modal.show('invite-user')
    },
    deleteInvite (invite) {
      InviteService.delete(invite.uuid).then(() => {
        this.fetchInvoiceData()
      })
    },
    sendInvite () {
      this.invite.loading = true

      InviteService.send(this.invite.model).then((res) => {
        this.$modal.hide('invite-user')

        this.invite.model = {
          email: null,
          role: null
        }

        if (res.data === 'member.added') {
          this.fetchData()
        }
      }).catch((err) => {
        this.invite.form.$errors = err.response.data.errors
      }).finally(() => {
        this.invite.loading = false
      })
    },
    fetchData () {
      MemberService.index(this.page).then((response) => {
        this.setData(response.data)
      })
    },
    async fetchInvoiceData () {
      this.invites = await InviteService.index()
    }
  }
}
</script>
